/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function EllipsisHorizontalIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "ellipsis-horizontal", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6.5 11C7.32843 11 8 11.6716 8 12.5C8 13.3284 7.32843 14 6.5 14C5.67157 14 5 13.3284 5 12.5C5 11.6716 5.67157 11 6.5 11Z", fill: "currentColor" }),
        React.createElement("path", { d: "M12.5 11C13.3284 11 14 11.6716 14 12.5C14 13.3284 13.3284 14 12.5 14C11.6716 14 11 13.3284 11 12.5C11 11.6716 11.6716 11 12.5 11Z", fill: "currentColor" }),
        React.createElement("path", { d: "M18.5 11C19.3284 11 20 11.6716 20 12.5C20 13.3284 19.3284 14 18.5 14C17.6716 14 17 13.3284 17 12.5C17 11.6716 17.6716 11 18.5 11Z", fill: "currentColor" })));
}
const ForwardRef = React.forwardRef(EllipsisHorizontalIcon);
export default ForwardRef;
//# sourceMappingURL=ellipsisHorizontalIcon.js.map